// @ts-strict-ignore
import {Component, forwardRef, Input, OnInit, output} from "@angular/core";
import {Translations} from "@translations";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {AssessablePanelMode} from "@common/components/assessment/utils";
import {distinctUntilChanged} from "rxjs/operators";

@UntilDestroy()
@Component({
	selector: "sim-note-area",
	templateUrl: "./note-area.component.html",
	styleUrls: ["./note-area.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => NoteAreaComponent),
			multi: true,
		},
	],
	standalone: false,
})
export class NoteAreaComponent implements ControlValueAccessor, OnInit {
	// Enums
	protected readonly T = Translations;
	protected readonly AssessablePanelMode = AssessablePanelMode;

	@Input() mode: AssessablePanelMode = AssessablePanelMode.View;
	@Input() inEditMode = false;
	@Input() canEnterEditMode = false;

	onNoteButtonClick = output<void>();

	public from = new FormControl("");

	public ngOnInit() {
		this.from.valueChanges.pipe(untilDestroyed(this), distinctUntilChanged()).subscribe((v) => {
			this.onChange(v);
		});
	}

	@Input()
	set value(value: string) {
		this.from.setValue(value);
	}
	public get value(): string {
		return this.from.value;
	}

	public writeValue(obj: any): void {
		this.value = obj;
	}
	public onChange: any = () => {};
	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	public onTouched: any = () => {};
	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	public setDisabledState(isDisabled: boolean): void {
		isDisabled ? this.from.disable() : this.from.enable();
	}
}
